export const ProductDesignInputFieldLabels = {
  title: 'Title',
  essentialRequirements: 'Essential Requirements',
  risk: 'Risk',
  description: 'Description',
  verificationMethod: 'Verification Method',
  whenToVerify: 'When to Verify',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  assignUserNeed: 'Assign User Need',
  assignDesignOutput: 'Assign Design Output',
  assignVerification: 'Assign Verification',
  assignValidation: 'Assign Validation',
  assignDesignSpec: 'Assign Design Spec',
  attachment: 'Attachments',
  components: 'Components',
  release: 'Release'
} as const;

export type ProductDesignInputField =
  keyof typeof ProductDesignInputFieldLabels;

export const ProductDesignInputFields: ProductDesignInputField[] = Object.keys(
  ProductDesignInputFieldLabels
) as ProductDesignInputField[];
